import { Component, OnInit } from '@angular/core';
import { SearchService } from '../../services/search-service.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class SearchComponent implements OnInit {
  public searchDetails: any = [];
  public results: any[];
  public refFilterResult: any = [];
  public first = 0;
  public rows = 10;
  public searchItems: any;
  public searchResults: any = [];
  public categoryTypes: any[];
  public isLandTypes: any = [];
  public amentisTypes: any = [];
  public moreIsland: boolean = true;
  public moreAmendments: boolean = true;
  public nearByIslands: any = [];
  public selectedCats: any = [];
  public selectedIslands: any = [];
  public selectedFacilities: any = [];
  public refIslandList: any = [];
  public refamentsList: any = [];
  public routeState: any;
  public textEnter: any;
  public viewMoreDetails: any = [];
  public viewMoreRecords: any = [];
  public pageNumber = 1;
  public src = '../../assets/images/NoImage.jpg';
  public newserachResults: any = [];
  public isSearchResultsShow = false;
  public classifications: string;
  public isFromNearIslands: boolean = false;
  public latestSearchCategories: any = [];
  public innerIsLandType: string;
  public totalRecords: number = 0;
  public searchmodelclose = true;
  public searchComponentVisible = false;
  public selectedCategory: any;
  public isTextFromOutSide: boolean;
  public selectedOrganisationValue: string;
  language: string;
  noOfPages: any;
  isViewMoreRecords: boolean;
  attributesDes: any;
  displayCustom: boolean;
  activeIndex: any;
  images: any = ['../../../assets/images/banner-accommodation.avif'];

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private searchService: SearchService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.language = localStorage.getItem('language');
    this.route.paramMap.subscribe((paramMap) => {
      this.textEnter = paramMap.get('searchTerm');
      if (this.textEnter.includes('...')) {
        this.textEnter = this.textEnter.slice(0, this.textEnter.length - 3);
      }
      localStorage.setItem('selectedValues', this.textEnter);
      this.getSearchDetails();
      this.getAmenties();
      this.getIslands();
    });

    this.isTextFromOutSide = true;

    this.categoryTypes = [
      { id: 'ACCOMM', name: 'Accommodation' },
      { id: 'ATTRACTION', name: 'Attraction' },
      { id: 'DESTINFO', name: 'Destination Information' },
      { id: 'EVENT', name: 'Event' },
      { id: 'RESTAURANT', name: 'Food & Drinks' },
      { id: 'GENSERVICE', name: 'General Service' },
      { id: 'HIRE', name: 'Hire' },
      { id: 'INFO', name: 'Information Services' },
      { id: 'JOURNEY', name: 'Journeys' },
      { id: 'TOUR', name: 'Tour' },
      { id: 'TRANSPORT', name: 'Transport' },
      { id: 'TOUROPERATOR', name: 'Tour Operators' },
    ];
  }
  async getIslands() {
    await this.searchService.islandTypes(null, null, this.textEnter).subscribe((data: any) => {
      this.isLandTypes = data.facetGroups.facetGroupFields;
    });
  }
  async getAmenties() {
    this.searchService.getAttributes().then((attributes) => {
      if (attributes) {
        this.attributesDes = attributes[1].Attributes;
        this.searchService.ameniesTypes(null, null, this.textEnter).subscribe(async (data: any) => {
          this.amentisTypes = data.facetGroups.facetGroupFields;
          let amentiesArray: any = [];
          if (data.facetGroups.facetGroupFields != null && data.facetGroups.facetGroupFields != undefined) {
            Array.from(data.facetGroups.facetGroupFields).map(async (attData: any) => {
              if (attData.name.startsWith('ENTITYFAC')) {
                let [prefix, amentiesId] = attData.name.split('ENTITYFAC');
                if (this.attributesDes) {
                  let res = this.attributesDes.filter((product: any) => {
                    if (product.AttributeId == amentiesId) return product.Description;
                  });
                  attData.Description = res[0].Description;
                  amentiesArray.push(attData);
                }
              }

              this.amentisTypes = amentiesArray;
            });
          }
        });
      }
    });
  }

  // closepopup()
  // {
  //   this.searchmodelclose = false;
  //   this.searchComponentVisible = true;
  // }

  clearCategory() {
    this.selectedCats = [];
    this.selectedCategory = [];
    this.selectCategeory(this.selectedCats);
  }
  selectCategeory(categoryType: any) {
    this.selectedCats = [];
    // this.selectedCategory=categoryType;
    if (!this.isFromNearIslands) {
      for (var i = 0; i < this.selectedCategory.length; i++) {
        this.selectedCats.push(this.selectedCategory[i].id);
      }
      // var index = this.selectedCats.indexOf(categoryType.id);
      // console.log("this.selectedCats",this.selectedCats);
      // if (index > -1) {
      //   this.selectedCats.splice(index, 1);
      // } else {
      //   this.selectedCats.push(categoryType.id);
      // }
      this.classifications = '';
      this.latestSearchCategories;
    }
    this.isTextFromOutSide = false;
    this.pageNumber = 1;
    this.getSearchDetails(this.pageNumber);
    //this.searchByValue(this.selectedCats);
    this.isFromNearIslands = false;

    this.isShowViewMore();
  }
  searchToggle() {
    const element = document.getElementById('SearchToggle');
    element.classList.toggle('expanded');
  }
  clearAmentments() {
    this.selectedFacilities = [];
    this.refamentsList = [];
    this.selectAmentments(this.selectedFacilities);
  }
  selectAmentments(amentmentType: any) {
    this.refamentsList = [];
    for (var i = 0; i < this.selectedFacilities.length; i++) {
      this.refamentsList.push(this.selectedFacilities[i].name);
    }
    this.isTextFromOutSide = false;
    this.pageNumber = 1;
    this.getSearchDetails(this.pageNumber);
    this.isShowViewMore();
  }
  clearIsLand() {
    this.selectedIslands = [];
    this.refIslandList = [];
    this.selectIsLand(this.selectedIslands);
  }
  selectIsLand(isLandType: any) {
    this.refIslandList = [];
    // for (var i = 0; i < this.selectedIslands.length; i++) {
    //   this.refIslandList.push(this.selectedIslands[i].name);
    // }
    this.refIslandList = this.selectedIslands.map((landTypes: any) => landTypes.name).join(',');
    //  this.refIslandList = refIslandList.landTypes.map((landTypes: any) => landTypes.name).join(',');
    //  this.refIslandList = search.landTypes.map((landTypes: any) => landTypes.name).join(',');
    this.isTextFromOutSide = false;
    this.pageNumber = 1;
    this.getSearchDetails(this.pageNumber);
    this.isShowViewMore();
  }
  // selectClassifications(classifications: any)
  // {
  //   this.searchResults
  //   this.classificationList = [];
  // }
  getSearchDetails(pageNumber?: number, isViewMore?: boolean) {
    var selectedTerm = localStorage.getItem('selectedValues');
    selectedTerm = `${selectedTerm}`;
    this.searchService
      .getSearchInfo(selectedTerm, pageNumber, this.selectedCats, this.refIslandList, this.refamentsList)
      .subscribe((data) => {
        if (data) {
          this.searchItems = data;
          this.totalRecords = this.searchItems.numberOfResults;
          this.noOfPages = this.totalRecords / 10;
          this.isShowViewMore();
          if (isViewMore) {
            for (var i = 0; i < this.searchItems.products.length; i++) {
              this.searchResults.push(this.searchItems.products[i]);
            }
            this.isSearchResultsShow = true;
          } else {
            this.searchResults = [];
            this.searchResults = this.searchItems.products;
            this.isSearchResultsShow = true;
          }
          this.searchResults.forEach((el: any) => {
            if (el.productDescription.length > 30) {
              el.productDescription = el.productDescription.substr(0, 100) + '...';
            }
            el.addresses.forEach((ele: any) => {
              if (ele.country == 'Seychelles') {
                el.currency = 'SCR';
              } else {
                el.currency = '$';
              }
              el.island = ele.island;
            });
          });
        }
      });
  }
  getSearchInfo() {}
  isShowViewMore() {
    if (this.noOfPages) {
      if (this.pageNumber < this.noOfPages) this.isViewMoreRecords = true;
      else this.isViewMoreRecords = false;
    } else {
      this.isViewMoreRecords = false;
    }
  }
  viewMoreDetils(productId: number) {
    var url = '/listingdetails/' + productId;
    window.open(url, '_blank');
  }
  searchForIslands(searchText: any) {
    for (var i = 0; i < this.isLandTypes.length; i++) {
      if (this.isLandTypes[i].name.toLowerCase().includes(searchText.query)) {
        this.isLandTypes.push(this.isLandTypes[i].name);
      }
    }
  }
  search(events: any) {
    var event = events.query.toLowerCase();
    this.refFilterResult = [];
    this.searchService.getSearchInfo(event).subscribe(
      (data) => {
        this.searchDetails = [];
        this.searchDetails = data;
        this.totalRecords = this.searchDetails.numberOfResults;
        this.noOfPages = this.totalRecords / 10;
        this.isShowViewMore();
        this.results = this.searchDetails.products;
        for (var i = 0; i < this.results.length; i++) {
          if (this.results[i].productNumber.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productNumber);
          } else if (this.results[i].productCategoryId.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productCategoryId);
          } else if (this.results[i].productDescription.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productDescription.substr(0, 100) + '...');
          } else if (this.results[i].owningOrganisationId.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].owningOrganisationId);
          } else if (this.results[i].owningOrganisationName.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].owningOrganisationName);
          } else if (this.results[i].owningOrganisationNumber.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].owningOrganisationNumber);
          } else if (this.results[i].productId.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productId);
          } else if (this.results[i].productName.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productName);
          } else if (this.results[i].productPixelURL.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].productPixelURL);
          }
          if (this.results[i].addresses[0].address_type.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].address_type);
          } else if (this.results[i].addresses[0].address_line.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].address_line);
          } else if (this.results[i].addresses[0].islandType.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].islandType);
          } else if (this.results[i].addresses[0].island.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].island);
          } else if (this.results[i].addresses[0].country.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].country);
          } else if (this.results[i].addresses[0].state.toLowerCase().includes(event)) {
            this.refFilterResult.push(this.results[i].addresses[0].state);
          }
          this.newserachResults = this.refFilterResult;
        }
      },
      (err) => {
        this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
      }
    );
  }
  searchByValue(selecedValue: any, pageNumber?: number, isViewMore?: boolean) {
    // localStorage.removeItem('selectedValues');
    localStorage.setItem('selectedValues', selecedValue);
    this.searchService
      .searchListingInfo(
        this.selectedCats,
        this.classifications,
        this.refIslandList,
        this.innerIsLandType,
        this.refamentsList,
        null,
        pageNumber
      )
      .subscribe(
        (data) => {
          this.searchItems = data;
          this.totalRecords = this.searchItems.numberOfResults;
          this.noOfPages = this.totalRecords / 10;
          this.isShowViewMore();
          if (isViewMore) {
            for (var i = 0; i < this.searchItems.products.length; i++) {
              this.searchResults.push(this.searchItems.products[i]);
            }
            this.isSearchResultsShow = true;
          } else {
            this.searchResults = [];
            this.searchResults = this.searchItems.products;
            this.isSearchResultsShow = true;
          }
          this.searchResults.forEach((el: any) => {
            if (el.productDescription.length > 30) {
              el.productDescription = el.productDescription.substr(0, 100) + '...';
            }
            el.addresses.forEach((ele: any) => {
              if (ele.country == 'Seychelles') {
                el.currency = 'SCR';
              } else {
                el.currency = '$';
              }
              if (ele.address_type == 'PHYSICAL') {
                el.island = ele.island;
                el.islandArea = ele.islandArea;
              }
            });
          });
        },
        (err) => {
          this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
        }
      );
  }
  ViewMoreRecord() {
    var selecedValue = localStorage.getItem('selectedValues');
    this.pageNumber = this.pageNumber + 1;
    // if (this.isTextFromOutSide) {
    this.getSearchDetails(this.pageNumber, true);
    // } else {
    //   this.searchByValue(selecedValue, this.pageNumber, true);
    // }
    this.isShowViewMore();
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
